import { Component, OnInit, Input, ChangeDetectorRef, OnDestroy } from "@angular/core";
import { Observable } from "rxjs";
import { LayoutService } from "../../../../core";
import { SubheaderService } from "../_services/subheader.service";
import { BreadcrumbItemModel } from "../_models/breadcrumb-item.model";
import { NavigationEnd, Router } from "@angular/router";
import { filter, takeUntil } from "rxjs/operators";
import { FacturacionIndividualService } from "src/app/services/facturacion-individual.service";
import { InvoicingButton } from "src/app/shared/models/InvoicingButton.enum";
import { Subject } from "rxjs";
import { InvoiceType } from "src/app/models/Dte/invoiceType.enum";
import { EmisionBheService } from "src/app/services/emision-bhe.service";
import { PlanUsuarioService } from "src/app/services/planUsuario.service";
import { FoliosService } from "src/app/services/folios.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { DatosFacturacionService } from "src/app/services/datos-facturacion-service";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { AccessibilityService } from "src/app/services/accessibility.service";
import { PaykuService } from "src/app/services/payku.service";
import { Emisor } from "src/app/models/Emisor/Emisor";
import { ChangeCompanyService } from "src/app/services/changecompany.service";

@Component({
	selector: "app-subheader1",
	templateUrl: "./subheader1.component.html",
	styleUrls: ["../../../../../../assets/deployAssets/theme/simplefactura.scss", "./subheader1.component.scss"],
})
export class Subheader1Component implements OnInit, OnDestroy {
	subheaderCSSClasses = "";
	subheaderContainerCSSClasses = "";
	subheaderMobileToggle = false;
	subheaderDisplayDesc = false;
	subheaderDisplayDaterangepicker = false;
	title$: Observable<string>;
	breadcrumbs$: Observable<BreadcrumbItemModel[]>;
	breadcrumbs: BreadcrumbItemModel[] = [];
	@Input() title: string;
	public showFacturacionButtonGroup: boolean = false;
	public showPlanOptions: boolean = false;
	invoicingClientDisabled$: Observable<boolean>;
	private payPlanModal: NgbModalRef;
	invoiceType$: Observable<InvoiceType>;
	currentType: InvoiceType;
	showFactGuiasButton: boolean = false;
	public disableButton = false;
	public showBheButtonGroup: boolean = false;
	public loadingFoliosSummary$: Observable<boolean>;
	public tipoCantidadFolio$: Observable<[string, number]>;
	public nombreTipoDteDisponible: string;
	public cantidadTipoDteDisponible: number;
	public currentTipoCantidad: any;
	public hasReseller: boolean = this.tokenService.userHasReseller();
	private unsubscribeEmisor$ = new Subject<void>();
	// Accessibility modal
	public isAccessibilityModalVisible: boolean = false;
	public isSimpleFonoModalVisible: boolean = false;
	public readonly simpleFonoOrigin: string = "SimpleFactura.App.Subheader.HablemosPorFono";
	public readonly simpleFonoShowAreas: boolean = false;
	public readonly simpleFonoFixedAreaCode: string = "soporte";
	public emisorId: string;
	public showButton: boolean = false;

	constructor(
		private layout: LayoutService, 
		private subheader: SubheaderService, 
		private router: Router, 
		private facturaService: FacturacionIndividualService, 
		private bheService: EmisionBheService, 
		private planUsuarioService: PlanUsuarioService, 
		private foliosService: FoliosService, 
		private tokenService: TokenStorageService,
		private accessibilityService: AccessibilityService,
		private paykuService: PaykuService,
		private ref: ChangeDetectorRef,
		private changeCompanyService: ChangeCompanyService
	) {
		this.title$ = this.subheader.titleSubject.asObservable();
		this.invoicingClientDisabled$ = this.facturaService.clientIsUnloadedObservable;
		this.invoiceType$ = this.facturaService.currentInvoiceTypeObservable;
		this.loadingFoliosSummary$ = this.foliosService.isLoadingFolios;
		this.tipoCantidadFolio$ = this.facturaService.tipoCantidadFolioObservable;
		this.emisorId = this.tokenService.getCompany();
	}

	ngOnInit() {
		
		this.changeCompanyService.companyChanged.pipe(takeUntil(this.unsubscribeEmisor$)).subscribe((newEmisor: Emisor) => {
			this.emisorId = newEmisor.emisorId;
			this.validatePaykuAdicional();
			this.ref.detectChanges();					
		});
		this.validatePaykuAdicional();
		this.title$ = this.subheader.titleSubject.asObservable();
		this.breadcrumbs$ = this.subheader.breadCrumbsSubject.asObservable();
		this.subheaderCSSClasses = this.layout.getStringCSSClasses("subheader");
		this.subheaderContainerCSSClasses = this.layout.getStringCSSClasses("subheader_container");
		this.subheaderMobileToggle = this.layout.getProp("subheader.mobileToggle");
		this.subheaderDisplayDesc = this.layout.getProp("subheader.displayDesc");
		this.subheaderDisplayDaterangepicker = this.layout.getProp("subheader.displayDaterangepicker");
		this.breadcrumbs$.subscribe((res) => {
			this.breadcrumbs = res;
			this.ref.detectChanges();
		});
		this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((val) => {
			if ((val as NavigationEnd).urlAfterRedirects == "/facturador-individual") {
				this.subheader.setTitle("");
				this.subheader.setBreadcrumbs([]);
				this.showFacturacionButtonGroup = true;
				this.showBheButtonGroup = false;
				this.nombreTipoDteDisponible = "";
			} else if ((val as NavigationEnd).urlAfterRedirects == "/emisor-boletas-honorarios") {
				this.subheader.setTitle("");
				this.subheader.setBreadcrumbs([]);
				this.showBheButtonGroup = true;
				this.showFacturacionButtonGroup = false;
			} else if ((val as NavigationEnd).urlAfterRedirects == "/plan") {
				this.subheader.setTitle("Mi cuenta");
				this.showFacturacionButtonGroup = false;
				this.showBheButtonGroup = false;
			} else {
				this.showFacturacionButtonGroup = (val as NavigationEnd).urlAfterRedirects == "/facturador-individual";
				this.showBheButtonGroup = false;
			}
			this.showPlanOptions = (val as NavigationEnd).urlAfterRedirects == "/plan";
		});
		this.invoicingClientDisabled$.subscribe((val) => (this.disableButton = val));
		this.invoiceType$.subscribe((type) => {
			this.currentType = type;
			if (this.currentType == InvoiceType.Factura) {
				this.showFactGuiasButton = true;
			} else {
				this.showFactGuiasButton = false;
			}
		});
		this.tipoCantidadFolio$.subscribe((tipoCantidad) => {
			this.currentTipoCantidad = tipoCantidad;
			if (tipoCantidad) {
				this.nombreTipoDteDisponible = tipoCantidad[0];
				this.cantidadTipoDteDisponible = tipoCantidad[1];
			} else {
				this.nombreTipoDteDisponible = "";
				this.cantidadTipoDteDisponible = 0;
			}
			this.ref.detectChanges();
		});
	}
	ngOnDestroy() {
		this.unsubscribeEmisor$.next();
		this.unsubscribeEmisor$.complete();
	}
	sendEmitAction() {
		this.facturaService.sendEmitAction();
	}

	sendPreviewAction() {
		this.facturaService.sendPreviewAction();
	}

	sendCancelAction() {
		this.facturaService.sendCancelAction();
	}

	sendEmitAndSaveAction() {
		this.facturaService.sendEmitAndSaveAction();
	}

	sendFacturaGuiasAction() {
		this.facturaService.sendFacturaGuiaAction();
	}

	sendEmitBheAction() {
		this.bheService.sendEmitAction();
	}

	sendCancelBheAction() {
		this.bheService.sendCancelAction();
	}
	openClickfono() {
		this.isSimpleFonoModalVisible = true;
	}

	openWhatsapp() {
		if (this.hasReseller) {
			window.open("https://api.whatsapp.com/send/?phone=" + this.tokenService.getReseller().telefonoContacto + "&text=Hola! Requiero soporte de SimpleFactura&type=phone_number&app_absent=0");
		} else {
			window.open("https://api.whatsapp.com/send/?phone=56975553937&text=Hola! Requiero soporte de SimpleFactura");
		}
	}

	closeExtendModal() {
		this.payPlanModal.close();
	}

	public openAccessibilityModal(): void {
		this.isAccessibilityModalVisible = true;
	}

	public closeAccessibilityModal(): void {
		this.isAccessibilityModalVisible = false;
	}

	public closeSimpleFonoModal(): void {
		this.isSimpleFonoModalVisible = false;
	}

	private validatePaykuAdicional(): void {
		if (!this.emisorId) {
			this.showButton = false;
			return;
		}
		this.paykuService.validarPaykuConPeriodoSemana(this.emisorId).subscribe({
			next: (mostrarBoton) => {
			this.showButton = mostrarBoton;
			this.ref.detectChanges();
			},
			error: (error) => {
			console.error('Error validando Payku adicional:', error);
			this.showButton = false;
			this.ref.detectChanges();
			}
		});
	}	
}
